export default {
  setBlogposts(state, blogposts) {
    state.blogposts = blogposts;
  },
};
